import React from "react";
import * as Bananas from "bananas-commerce-admin";

import ErrorCard from "@/extensions/klarahill/components/ErrorCard";
import OrdersList from "@/extensions/mediahouse/components/OrdersList";
import { ObituaryMediaResponse } from "@/extensions/mediahouse/types";

export interface OrdersTabProps {
  orders: ObituaryMediaResponse[];
}

const OrdersTab: React.FC<OrdersTabProps> = ({ orders }) => {
  if (orders.length === 0) {
    return (
      <Bananas.Content layout="fullWidth">
        <ErrorCard errorMessage="Hittade inga ordrar för denna utgivning." />
      </Bananas.Content>
    );
  }

  return (
    <Bananas.Content layout="fullWidth">
      <OrdersList
        data={orders}
        showDeceased={false}
        showPublicationAbbreviation={false}
      />
    </Bananas.Content>
  );
};

export default OrdersTab;
